package com.shadowings.gero.domain.reminder

private class WebQuizReminderScheduler : QuizReminderScheduler {
    override fun cancelReminder() {}
    override fun scheduleReminder(dateAsInt: Int, hour: Int, minute: Int) {}
}

actual fun createQuizReminderScheduler(): QuizReminderScheduler = WebQuizReminderScheduler()
